<script setup>
    import { useI18n } from 'vue-i18n';
    import { useLinks } from '../../links';
    import Socials from './Socials.vue';

    const { t } = useI18n();
    const { getLink } = useLinks();

    const savickiBrandLinks = [
        {
            title: t('footer.link1'),
            link: getLink('o-nas'),
        },
        {
            title: t('footer.link2'),
            link: getLink('wartosci-savicki'),
        },
        {
            title: t('footer.link3'),
            link: getLink('nasze-salony'),
        },
        // {
        //     title: 'Kariera',
        //     link: getLink('kariera'),
        // },
        {
            title: t('footer.link4'),
            link: getLink('bizuteria-na-zamowienie'),
        },
        {
            title: t('footer.link5'),
            link: getLink('kontakt'),
        },
    ]

    const onlineShoppingLinks = [
        {
            title: t('footer.link6'),
            link: getLink('status'),
        },
        {
            title: t('footer.link7'),
            link: getLink('zwroty-i-reklamacje'),
        },
        {
            title: t('footer.link8'),
            link: getLink('karta-podarunkowa-savicki'),
        },
        {
            title: t('footer.link9'),
            link: getLink('zwroty-i-reklamacje'),
        },
        {
            title: t('footer.link10'),
            link: getLink('gwarancja'),
        },
        {
            title: t('footer.link11'),
            link: getLink('wysylka-i-platnosci'),
        },
        {
            title: t('footer.link12'),
            link: getLink('polityka-prywatnosci'),
        },
        {
            title: t('footer.link13'),
            link: getLink('regulamin'),
        },
        {
            title: t('footer.link14'),
            link: getLink('regulamin-karty-podarunkowej'),
        },
    ]


    const helpfulLinks = [
        {
            title: t('footer.link15'),
            link: getLink('najczesciej-zadawane-pytania-faq'),
        },
        {
            title: t('footer.link16'),
            link: getLink('jak-kupowac'),
        },
        {
            title: t('footer.link17'),
            link: getLink('jak-zmierzyc-rozmiar-pierscionka'),
        },
        {
            title: t('footer.link18'),
            link: getLink('tabela-rozmiarow'),
        },
        {
            title: t('footer.link19'),
            link: getLink('skup-zlota'),
        },
        {
            title: t('footer.link20'),
            link: getLink('certyfikaty-jakosci'),
        },
        {
            title: 'Conflict Free Diamonds',
            link: getLink('conflict-free-diamonds'),
        },
    ]

    const paymentMethods = [
        {
            title: 'Blik',
            img: '/images/payment-methods/blik.svg',
        },
        {
            title: 'PayU',
            img: '/images/payment-methods/payu.svg',
        },
        {
            title: 'Apple Pay',
            img: '/images/payment-methods/applepay.svg',
        },
        {
            title: 'Google Pay',
            img: '/images/payment-methods/googlepay.svg',
        },
    ]

    const deliveryMethods = [
        {
            title: 'UPS',
            img: '/images/delivery-methods/ups.ups.svg',
        },
        {
            title: 'DHL',
            img: '/images/delivery-methods/dhl.dhl.svg',
        },
        {
            title: 'Inpost',
            img: '/images/delivery-methods/inpost.inpost.svg',
        },
        {
            title: 'GLS',
            img: '/images/delivery-methods/gls.gls.svg',
        },
    ]

    const savickiBrandLinksFiltered = savickiBrandLinks.filter(link => !!link.link);
    const onlineShoppingLinksFiltered = onlineShoppingLinks.filter(link => !!link.link);
    const helpfulLinksFiltered = helpfulLinks.filter(link => !!link.link);
</script>

<template>
    <footer>
        <div class="container text-center text-lg-start">

            

            <div class="d-flex justify-content-center justify-content-lg-start align-items-center mb-4 mb-lg-5">
                <a :href="getLink('/')">
                    <img src="/images/logo-savicki-no-claim.svg" alt="logo" height="28" class="" loading="eager" />
                </a>
            </div>

            <Socials class="d-lg-none mb-4 mb-lg-5" />

            <div class="grid mb-4 mb-lg-5">
                <div class="g-col-12 g-col-lg-3">
                    <p class="fw-bold fs-7" data-bs-toggle="collapse" data-bs-target="#savickiBrandLinks">
                        {{ $t('home-new.text10') }}
                    </p>

                   <div id="savickiBrandLinks" class="collapse show">
                    <div class="d-flex flex-column gap-2">
                        <a v-for="link in savickiBrandLinksFiltered" :key="link.title" :href="link.link" class="d-block text-decoration-none text-body-secondary fs-7" target="_blank">
                            {{ link.title }}
                        </a>
                    </div>
                   </div>
                </div>
                <div class="g-col-12 g-col-lg-3">
                    <p class="fw-bold fs-7" data-bs-toggle="collapse" data-bs-target="#onlineShoppingLinks">
                        {{ $t('home-new.text11') }}
                    </p>

                    <div id="onlineShoppingLinks" class="collapse show">
                        <div class="d-flex flex-column gap-2">
                            <a v-for="link in onlineShoppingLinksFiltered" :key="link.title" :href="link.link" class="d-block text-decoration-none text-body-secondary fs-7" target="_blank">
                                {{ link.title }}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="g-col-12 g-col-lg-3">
                    <p class="fw-bold fs-7" data-bs-toggle="collapse" data-bs-target="#helpfulLinks">
                        {{ $t('home-new.text12') }}
                    </p>

                    <div id="helpfulLinks" class="collapse show">
                        <div class="d-flex flex-column gap-2">
                            <a v-for="link in helpfulLinksFiltered" :key="link.title" :href="link.link" class="d-block text-decoration-none text-body-secondary fs-7" target="_blank">
                                {{ link.title }}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="g-col-12 g-col-lg-3">
                    <p class="fw-bold fs-7">
                        {{ $t('home-new.text13') }}:
                    </p>

                    <div class="d-flex justify-content-center justify-content-lg-start align-items-center gap-3 mb-3 mb-lg-4">
                        <img v-for="method in paymentMethods" :key="method.title" :src="method.img" :alt="method.title" height="16" class="" loading="lazy" />
                    </div>

                    <p class="fw-bold fs-7">
                        {{ $t('home-new.text14') }}:
                    </p>

                    <div class="d-flex justify-content-center justify-content-lg-start align-items-center gap-3">
                        <img v-for="method in deliveryMethods" :key="method.title" :src="method.img" :alt="method.title" height="32" class="" loading="lazy" />
                    </div>
                </div>
            </div>
        </div>

        <hr class="my-4 my-lg-5" />

        <div class="container">
            <Socials class="d-none d-lg-flex" />
        </div>
    </footer>
</template>